/**
 * Client Mod 容器初始化（浏览器版本）
 *
 * 加载 UI Registry、Client Runtime 以及业务 Mods，
 * 注册 browser-fetch-service-mod（基于原生 fetch）。
 *
 * SPA 端使用此入口。
 */

import { ModContainer } from 'hvsin'
import { uiRegistryMod } from '@hvsin/mod-ui-registry'
import { routeMod } from '@hvsin/mod-route'
import { clientRuntimeMod } from '@hvsin/mod-client-runtime'
import { helloworldClientMod } from '@hvsin/mod-helloworld-client'
import { helloGreetingClientMod } from '@hvsin/mod-hello-greeting-client'
import { userClientMod } from '@hvsin/mod-user-client'
import { userCenterClientMod } from '@hvsin/mod-user-center-client'
import { adminClientMod } from '@hvsin/mod-admin-client'
import { sampleSlotClientMod } from '@hvsin/mod-sample-slot-client'
import { postClientMod } from '@hvsin/mod-post-client'
import { todoClientMod } from '@hvsin/mod-todo-client'
import { noteClientMod } from '@hvsin/mod-note-client'
import { pwaLinksClientMod } from '@hvsin/mod-pwa-links-client'
import { homePageSettingClientMod } from '@hvsin/mod-home-page-setting-client'
import { browserFetchServiceMod } from '@hvsin/mod-browser-fetch-service'

/**
 * 初始化浏览器客户端容器
 *
 * 按照客户端 bundle 所需的依赖顺序加载 Mod：
 * 1. ui-registry（注册中心）
 * 2. browser-fetch-service（基于原生 fetch 的 HTTP 调用，必须在前端业务 mod 之前加载）
 * 3. helloworld-client（业务示例）
 * 4. hello-greeting-client（业务示例）
 * 5. user-center-client + sample-slot-client（用户中心 + slot 扩展示例）
 * 6. admin-client-mod（管理员中心，支持 slot 扩展）
 * 7. post-client-mod（文章管理，通过 Slot 注入用户中心）
 * 8. client-runtime（运行时层）
 */
export async function initBrowserContainer(): Promise<ModContainer> {
  const container = new ModContainer()

  console.log('[BrowserInitContainer] Loading mods...')
  await container.loadMods([
    uiRegistryMod,          // 1. 注册中心
    routeMod,               // 2. 路由抽象层
    browserFetchServiceMod, // 3. 浏览器 fetch 服务（原生 fetch，必须在 postClientMod 之前）
    helloworldClientMod,    // 4. Helloworld 示例
    helloGreetingClientMod, // 5. Greeting 示例
    userClientMod(),
    userCenterClientMod,
    sampleSlotClientMod,    // 6. 用户中心 + slot 扩展示例
    adminClientMod,         // 7. 管理员中心（支持 slot 扩展）
postClientMod,          // 8. 文章管理（通过 Slot 注入用户中心）
todoClientMod,          // 9. 待办事项
noteClientMod,          // 10. 笔记管理
pwaLinksClientMod,      // 11. PWA 导航（公开页 + Admin Slot）
    homePageSettingClientMod, // 12. 首页设置（Admin Slot）
    clientRuntimeMod,       // 13. 运行时层（初始化路由但不挂载 DOM）
  ])
  console.log('[BrowserInitContainer] All mods loaded ✓')

  return container
}
